"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getOppositePosition = getOppositePosition;
exports.isVerticalPosition = isVerticalPosition;
exports.capitalize = capitalize;
exports.fromPopperPlacement = fromPopperPlacement;
exports.splitPlacement = splitPlacement;
exports.getPopoverMarginStyles = getPopoverMarginStyles;
exports.getStartPosition = getStartPosition;
exports.getEndPosition = getEndPosition;
exports.getArrowPositionStyles = getArrowPositionStyles;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _constants = require("./constants.js");

/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable import/prefer-default-export */
var OPPOSITE_POSITIONS = {
  top: "bottom",
  bottom: "top",
  right: "left",
  left: "right"
};
/**
 * Returns the opposite of the specified position. Useful for tooltip
 * positioning logic.
 * Examples:
 * top -> bottom
 * left -> right
 */

function getOppositePosition(position) {
  return OPPOSITE_POSITIONS[position];
}
/**
 * Determines whether or not the specified position is a vertical one (top or bottom)
 */


function isVerticalPosition(position) {
  return position === "top" || position === "bottom";
}
/**
 * Simple utility function for capitalizing the first letter of a string
 */


function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
/**
 * Opposite of function above, converts from Popper.js placement
 * to our placement prop
 */


function fromPopperPlacement(placement) {
  var popoverPlacement = placement.replace(/(top|bottom)-start$/, "$1Left").replace(/(top|bottom)-end$/, "$1Right").replace(/(left|right)-start$/, "$1Top").replace(/(left|right)-end$/, "$1Bottom");
  return _constants.PLACEMENT[popoverPlacement] || null;
}
/**
 * Splits something like 'topLeft' to ['top', 'left'] for easier usage
 */


function splitPlacement(placement) {
  var matches = placement.match(/^([a-z]+)([A-Z][a-z]+)?/) || [];
  return matches.slice(1, 3).filter(Boolean).map(function (s) {
    return s.toLowerCase();
  });
}
/**
 * Returns margin styles to add spacing between the popover
 * and its anchor.
 *
 * We may eventually want to make margin a prop that can be overridden.
 */


function getPopoverMarginStyles(showArrow, placement) {
  var _splitPlacement = splitPlacement(placement),
      _splitPlacement2 = (0, _slicedToArray2["default"])(_splitPlacement, 1),
      position = _splitPlacement2[0];

  var opposite = getOppositePosition(position);

  if (!opposite) {
    return null;
  }

  var property = "margin".concat(capitalize(opposite));
  return (0, _defineProperty2["default"])({}, property, "".concat(showArrow ? _constants.ARROW_SIZE : _constants.POPOVER_MARGIN, "px"));
}
/**
 * Returns CSS rules for the popover animation start keyframe
 */


function getStartPosition(offset, placement, showArrow) {
  offset = (0, _objectSpread2["default"])({}, offset);

  var _splitPlacement3 = splitPlacement(placement),
      _splitPlacement4 = (0, _slicedToArray2["default"])(_splitPlacement3, 1),
      position = _splitPlacement4[0];

  var margin = (showArrow ? _constants.ARROW_SIZE : _constants.POPOVER_MARGIN) * 2;

  if (isVerticalPosition(position)) {
    offset.top += position === "top" ? margin : -margin;
  } else {
    offset.left += position === "left" ? margin : -margin;
  }

  return "translate3d(".concat(offset.left, "px, ").concat(offset.top, "px, 0)");
}
/**
 * Returns CSS rules for the popover animation end keyframe
 */


function getEndPosition(offset) {
  return "translate3d(".concat(offset.left, "px, ").concat(offset.top, "px, 0)");
}
/**
 * Returns top/left styles to position the popover arrow
 */


function getArrowPositionStyles(offsets, placement) {
  var _ref2;

  var _splitPlacement5 = splitPlacement(placement),
      _splitPlacement6 = (0, _slicedToArray2["default"])(_splitPlacement5, 1),
      position = _splitPlacement6[0];

  var oppositePosition = getOppositePosition(position);

  if (!oppositePosition) {
    return null;
  }

  var alignmentProperty = isVerticalPosition(position) ? "left" : "top";
  return _ref2 = {}, (0, _defineProperty2["default"])(_ref2, alignmentProperty, "".concat(offsets[alignmentProperty], "px")), (0, _defineProperty2["default"])(_ref2, oppositePosition, "-".concat(_constants.ARROW_SIZE - 2, "px")), _ref2;
}